import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import iPad from '@/components/iPad'
import iPhone from '@/components/iPhone'
import Blog from '@/components/Blog'
import Soup from '@/components/Soup'

Vue.use(Router)

const routes = [
  { path: '/', component: Home },
  { path: '/iPhone', component: iPhone },
  { path: '/iPad', component: iPad },
  { path: '/blog', component: Blog, props: { item: null } },
  { path: '/blog/off-the-bus', component: Blog, props: { item: 0 } },
  { path: '/iPad/Soup', component: Soup }
]

export default new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'is-active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js